import { getCvPortalTranslationOverrides } from "./getCvPortalTranslationOverrides";
import { getCustomerTimesheetDraftVisibility } from "./getCustomerTimesheetDraftVisibility";
import { getEnabledChoices } from "./getEnabledChoices";
import { getSettings } from "./getSettings";
import { getSettingsComplete } from "./getSettingsComplete";
import { getSettingsCompleteAsDictionary } from "./getSettingsCompleteAsDictionary";

export const settingsAPI = {
  getEnabledChoices,
  getSettings,
  getSettingsComplete,
  getSettingsCompleteAsDictionary,
  getCvPortalTranslationOverrides,
  getCustomerTimesheetDraftVisibility,
};
export type SettingsAPI = typeof settingsAPI;
